/*
 * Copyright (c) 2021-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {PureComponent} from 'react';
import PropTypes from "prop-types";
import Tooltip from "../Tooltip.jsx";

class EntityWrapperSmallLabel extends PureComponent {
    render() {
        let {inputWidth} = this.props
        return (
            <div className="h-full w-full flex flex-col">
                {this.props.label !== "" && (<>
                    <div className={"flex flex-row"}>
                        <label className="block text-sm font-medium text-gray-700  h-7 truncate flex-grow">
                            {this.props.label}
                        </label>
                        {(!this.props.isRequired && this.props.isRequired !== undefined && this.props.isRequired !== null) && (
                            <div className={" pl-2 "}>
                                <Tooltip text={<span>You can leave this field blank.  </span>}>
                                    <span className={"text-gray-500 italic text-xs font-light "}>  Optional </span>
                                </Tooltip>
                            </div>)}

                    </div>
                </>)}

                {(this.props.helpText !== undefined) && (
                    <p className="block text-xs font-light text-gray-700  mb-1.5 -mt-1  flex-grow">
                        {this.props.helpText}
                    </p>
                )}


                <div className=" flex-grow  " style={{width: inputWidth ?? "100%"}}>
                    {this.props.children}
                </div>
            </div>


        );
    }
}

EntityWrapperSmallLabel.propTypes = {
    label: PropTypes.string,
    helpText: PropTypes.string,
};
EntityWrapperSmallLabel.defaultProps = {
    label: ''
}

export default EntityWrapperSmallLabel;